import React from "react";
import { Button, Result } from "antd";
import { useTranslation } from "react-i18next";

const ProductUnavailable = () => {
  const { t } = useTranslation();
  return (
    <>
      <div style={{ display: "flex", justifyContent: "center", paddingTop: 25 }}>
        <img className="img-fluid" src={"/img/logo-white.png"} alt="" />
      </div>
      <Result
        status="404"
        title={t("productUnavailable.title")}
        subTitle={t("productUnavailable.subTitle")}
        extra={
          <div>
            <Button
              type="primary"
              onClick={() => {
                window.location.reload();
              }}
            >
              {t("productUnavailable.retryButton")}
            </Button>
          </div>
        }
      />
    </>
  );
};

export default ProductUnavailable;
